// Notification dropdown strings (auto-merged by lib/i18n.ts).
export const en = {
  'notif.title': 'Notifications',
  'notif.mark_all': 'Mark all read',
  'notif.tab.all': 'All',
  'notif.tab.unread': 'Unread',
  'notif.loading': 'Loading…',
  'notif.empty.title': "You're all caught up",
  'notif.empty.all': 'No notifications.',
  'notif.empty.unread': 'No unread notifications.',
  'notif.view_all': 'View all notifications',
  'notif.ago.now': 'just now',
  'notif.ago.minutes': '{n}m ago',
  'notif.ago.hours': '{n}h ago',
  'notif.ago.yesterday': 'yesterday',
  'notif.ago.days': '{n}d ago',
  'notif.bucket.today': 'Today',
  'notif.bucket.yesterday': 'Yesterday',
  'notif.bucket.this_week': 'This week',
  'notif.bucket.earlier': 'Earlier',
  'notif.aria.dialog': 'Notifications',
}

export const zhTW = {
  'notif.title': '通知',
  'notif.mark_all': '全部標示為已讀',
  'notif.tab.all': '全部',
  'notif.tab.unread': '未讀',
  'notif.loading': '載入中…',
  'notif.empty.title': '您已全部讀取完畢',
  'notif.empty.all': '沒有通知。',
  'notif.empty.unread': '沒有未讀通知。',
  'notif.view_all': '檢視所有通知',
  'notif.ago.now': '剛剛',
  'notif.ago.minutes': '{n} 分鐘前',
  'notif.ago.hours': '{n} 小時前',
  'notif.ago.yesterday': '昨天',
  'notif.ago.days': '{n} 天前',
  'notif.bucket.today': '今天',
  'notif.bucket.yesterday': '昨天',
  'notif.bucket.this_week': '本週',
  'notif.bucket.earlier': '更早',
  'notif.aria.dialog': '通知',
}
